import defaultSchema from './default.schema';

export default {
  ...defaultSchema,
  title: 'Kontener na punkty',
  type: 'object',
  properties: {
    benefitId: {
      title: 'Usługa',
      type: 'number',
      fieldRequired: true
    },
    pointContainerId: {
      type: 'number',
      title: 'Kontener na punkty',
      fieldRequired: true
    },
    points: {
      type: 'number',
      title: 'Punkty przyznane za użycie usługi',
      fieldRequired: true
    },
    maxUsagesPerUser: {
      type: 'number',
      title: 'Maksymalna ilość użyć (naliczeń punktów)',
      fieldRequired: false
    }
  }
};
